if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      
      // Add form submission handler
      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (form.dataset.type === 'add-to-cart-form') {
          event.preventDefault();
          const submitButton = form.querySelector('[type="submit"]');
          if (submitButton) submitButton.setAttribute('disabled', true);

          const formData = new FormData(form);

          formData.append('sections', 'cart-drawer');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          // Commented out by Bold support to allow subscription data to pass to the cart correctly
          // const data = {
          //   items: [{
          //     id: formData.get('id'),
          //     quantity: formData.get('quantity') || 1
          //   }],
          //   sections: ["cart-drawer"]
          // };

          // fetch(`${window.Shopify.routes.root}cart/add.js`, {
          //   method: 'POST',
          //   headers: {
          //     'Content-Type': 'application/json',
          //   },
          //   body: JSON.stringify(data)
          // })
          fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(data => {
            if (data.sections && data.sections["cart-drawer"]) {
              const cartContents = this.querySelector('.cart-items-wrapper');
              const parser = new DOMParser();
              const html = parser.parseFromString(data.sections["cart-drawer"], 'text/html');
              const newCartContents = html.querySelector('.cart-items-wrapper');
              
              if (newCartContents) {
                cartContents.innerHTML = newCartContents.innerHTML;
                this.classList.remove('is-empty');
                const checkoutBtn = this.querySelector('#CartDrawer-Checkout');
                if (checkoutBtn) checkoutBtn.removeAttribute('disabled');
              }
            }
            this.open();
            this.refreshCart();
            if (submitButton) submitButton.removeAttribute('disabled');
          })
          .catch((error) => {
            console.error('Error:', error);
            if (submitButton) submitButton.removeAttribute('disabled');
          });
        }
      });

      this.bindEvents();
      this.cartItemCount = 0;
      this.recommendationsLoaded = false;
      this.initHeaderCartIcon();
    }

    initHeaderCartIcon() {
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.setAttribute('role', 'button');
        cartIcon.setAttribute('aria-haspopup', 'dialog');
        cartIcon.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      }
    }

    bindEvents() {
      this.querySelector('.drawer__close').addEventListener('click', () => this.close());
      this.querySelector('.cart-drawer__overlay').addEventListener('click', () => this.close());
    
      // Click on cart-drawer (the overlay)
      this.addEventListener('click', (event) => {
        if (event.target === this.querySelector('.cart-drawer')) {
          this.close();
        }
      });
    
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('active')) {
          this.close();
        }
      });
      
      this.addEventListener('change', event => {
        if (event.target.matches('.quantity__input')) {
          this.updateQuantity(event);
        }
      });
    
      this.addEventListener('click', event => {
        if (event.target.closest('.cart-item__remove')) {
          event.preventDefault();
          const cartItem = event.target.closest('.cart-item');
          this.removeItem(cartItem);
        }
      });
      
      // Add new code for the checkout button
      const checkoutButton = this.querySelector('.cart-drawer__checkout');
      if (checkoutButton) {
        checkoutButton.addEventListener('click', (event) => {
          event.preventDefault();
          window.location.href = '/checkout';
        });
      }
    }

    async loadRecommendations() {
      if (this.recommendationsLoaded) return;
      
      try {
        const firstItem = document.querySelector('.cart-item');
        if (!firstItem) return;
        
        const productId = firstItem.dataset.productId;
        const response = await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${productId}&limit=4`);
        const data = await response.json();
        
        if (data.products && data.products.length > 0) {
          // Filter out products with 'wholesale' in the title
          const filteredProducts = data.products
            .filter(product => !product.title.toLowerCase().includes('wholesale'))
            .slice(0, 1); // Only take first product after filtering
    
          if (filteredProducts.length > 0) {
            const recommendationsList = this.querySelector('.cart-recommendations__list');
            recommendationsList.innerHTML = filteredProducts.map(product => {
              const imageUrl = product.featured_image || product.images[0];
              const width = 150;
              const height = 125;
              const formattedImageUrl = `${imageUrl}?v=${Date.now()}&width=${width}`;

              return `
                <div class="cart-recommendation" data-product-id="${product.id}" data-variant-id="${product.variants[0].id}">
                  <div class="cart-recommendation__media">
                    <img src="${formattedImageUrl}"
                      alt="${product.title}"
                      loading="lazy"
                      width="${width}"
                      height="${height}">
                  </div>
                  <div class="cart-recommendation__details">
                    <div class="cart-recommendation__content">
                      <h4 class="cart-recommendation__name">${product.title}</h4>
                      <div class="cart-recommendation__variant-row">
                        <span class="cart-recommendation__price">${this.formatMoney(product.variants[0].price)}</span>
                        ${product.variants.length > 1 ? `
                          <select class="cart-recommendation__variant-select">
                            ${product.variants.map(variant => `
                              <option value="${variant.id}" data-price="${this.formatMoney(variant.price)}">
                                ${variant.title}
                              </option>
                            `).join('')}
                          </select>
                        ` : ''}
                      </div>
                    </div>
                    <button type="button" class="cart-recommendation__add-button">Add</button>
                  </div>
                </div>
              `;
            }).join('');
            
            this.recommendationsLoaded = true;
            this.bindRecommendationEvents();
          }
        }
      } catch (error) {
        console.error('Error loading recommendations:', error);
      }
    }

    bindRecommendationEvents() {
      this.querySelectorAll('.cart-recommendation__variant-select').forEach(select => {
        select.addEventListener('change', this.handleVariantChange.bind(this));
      });

      this.querySelectorAll('.cart-recommendation__add-button').forEach(button => {
        button.addEventListener('click', this.handleAddToCart.bind(this));
      });
    }

    handleVariantChange(event) {
      const select = event.target;
      const recommendation = select.closest('.cart-recommendation');
      const price = select.selectedOptions[0].dataset.price;
      recommendation.querySelector('.cart-recommendation__price').textContent = price;
    }

    async handleAddToCart(event) {
      const button = event.target;
      const recommendation = button.closest('.cart-recommendation');
      const variantSelect = recommendation.querySelector('.cart-recommendation__variant-select');
      const variantId = variantSelect ? variantSelect.value : recommendation.dataset.variantId;

      try {
        button.disabled = true;
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }],
            sections: ["cart-drawer"]
          })
        });

        if (response.ok) {
          const data = await response.json();
          
          // Step 1: Animate recommendation away
          recommendation.classList.add('adding-to-cart');
          
          // Wait for the slide out animation to complete
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Step 2: Update cart contents but keep new item hidden
          if (data.sections && data.sections["cart-drawer"]) {
            const cartContents = this.querySelector('.cart-items-wrapper');
            const parser = new DOMParser();
            const html = parser.parseFromString(data.sections["cart-drawer"], 'text/html');
            const newCartContents = html.querySelector('.cart-items-wrapper');
            
            if (newCartContents) {
              // Find the newly added item
              const newItems = Array.from(newCartContents.children);
              const newItem = newItems.find(item => item.dataset.variantId === variantId);
              
              if (newItem) {
                // Add the new item with animation class
                newItem.classList.add('adding');
                
                // Update cart contents
                cartContents.innerHTML = newCartContents.innerHTML;
                this.classList.remove('is-empty');
                const checkoutBtn = this.querySelector('#CartDrawer-Checkout');
                if (checkoutBtn) checkoutBtn.removeAttribute('disabled');

                // Highlight the new item
                setTimeout(() => {
                  const addedItem = cartContents.querySelector(`[data-variant-id="${variantId}"]`);
                  if (addedItem) {
                    addedItem.classList.add('highlight');
                  }
                }, 500);
              }
            }
          }
          
          // Step 3: Load new recommendation
          await this.loadNewRecommendation(recommendation);
          
          // Step 4: Update cart count
          this.refreshCart();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        button.disabled = false;
      }
    }

    async loadNewRecommendation(oldRecommendation) {
      try {
        const firstItem = document.querySelector('.cart-item');
        if (!firstItem) return;
        
        const productId = firstItem.dataset.productId;
        const response = await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${productId}&limit=4`);
        const data = await response.json();

        if (data.products && data.products.length > 0) {
          // Filter out wholesale products
          const filteredProducts = data.products
            .filter(product => !product.title.toLowerCase().includes('wholesale'));

          if (filteredProducts.length > 0) {
            const newProduct = filteredProducts[0];
            const newRecommendation = document.createElement('div');
            newRecommendation.classList.add('cart-recommendation');
            newRecommendation.dataset.productId = newProduct.id;
            newRecommendation.dataset.variantId = newProduct.variants[0].id;
            newRecommendation.style.opacity = '0';

            const imageUrl = newProduct.featured_image || newProduct.images[0];
            const width = 150;
            const height = 125;
            const formattedImageUrl = `${imageUrl}?v=${Date.now()}&width=${width}`;
            
            newRecommendation.innerHTML = `
              <div class="cart-recommendation__media">
                <img src="${formattedImageUrl}"
                  alt="${newProduct.title}"
                  loading="lazy"
                  width="${width}"
                  height="${height}">
              </div>
              <div class="cart-recommendation__details">
                <div class="cart-recommendation__content">
                  <h4 class="cart-recommendation__name">${newProduct.title}</h4>
                  <div class="cart-recommendation__variant-row">
                    <span class="cart-recommendation__price">${this.formatMoney(newProduct.variants[0].price)}</span>
                    ${newProduct.variants.length > 1 ? `
                      <select class="cart-recommendation__variant-select">
                        ${newProduct.variants.map(variant => `
                          <option value="${variant.id}" data-price="${this.formatMoney(variant.price)}">
                            ${variant.title}
                          </option>
                        `).join('')}
                      </select>
                    ` : ''}
                  </div>
                </div>
                <button type="button" class="cart-recommendation__add-button">Add</button>
              </div>
            `;

            oldRecommendation.replaceWith(newRecommendation);
            
            requestAnimationFrame(() => {
              newRecommendation.style.transition = 'opacity 0.3s ease-in-out';
              newRecommendation.style.opacity = '1';
            });
            
            this.bindRecommendationEvents();
          }
        }
      } catch (error) {
        console.error('Error loading new recommendation:', error);
      }
    }

    async updateQuantity(event) {
      const input = event.target;
      const cartItem = input.closest('.cart-item');
      const quantity = parseInt(input.value);
      const variantId = cartItem.dataset.variantId;

      if (quantity === 0) {
        this.removeItem(cartItem);
        return;
      }

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        });

        const cart = await response.json();
        this.updateCartItem(cartItem, cart);
        this.updateCartCount(cart.item_count);

      } catch (error) {
        console.error('Error updating cart:', error);
        input.value = input.defaultValue;
      }
    }

    async removeItem(cartItem) {
      const variantId = cartItem.dataset.variantId;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 0
          })
        });

        const cart = await response.json();
        cartItem.remove();
        this.updateCartCount(cart.item_count);

        if (cart.item_count === 0) {
          this.classList.add('is-empty');
        }

      } catch (error) {
        console.error('Error removing item:', error);
      }
    }

    updateCartItem(cartItem, cart) {
      const variantId = cartItem.dataset.variantId;
      const cartItemData = cart.items.find(item => item.variant_id === parseInt(variantId));
      
      if (cartItemData) {
        const priceElement = cartItem.querySelector('.cart-item__price');
        priceElement.textContent = this.formatMoney(cartItemData.final_line_price);
      }
    }

    open() {
      this.classList.add('active');
      document.body.classList.add('drawer-open');
      this.removeInjectedCheckoutElements();
      this.loadRecommendations();
    }

    removeInjectedCheckoutElements() {
      const checkoutDiv = this.querySelector('.cart-drawer__checkout');
      if (!checkoutDiv) return;
      Array.from(checkoutDiv.children).forEach(el => {
        if (el.id !== 'CartDrawer-Checkout') el.remove();
      });
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('drawer-open');
    }

    updateCartCount(count) {
      this.cartItemCount = count;
      document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
        bubble.textContent = count;
        bubble.classList.toggle('is-empty', count === 0);
      });
    }

    async refreshCart() {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await response.json();
        this.updateCartCount(cart.item_count);
      } catch (error) {
        console.error('Error refreshing cart:', error);
      }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(cents / 100);
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}